import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import './index.css'
import App from './app/App.jsx'
import { store } from './app/store/index.js'
import { bindApiClientToStore } from './services/apiClient.js'

bindApiClientToStore(store)

// Note: StrictMode disabled due to compatibility issue with @monaco-editor/react
// The library's cleanup function has a bug that causes crashes during double-invocation
// See: https://github.com/suren-atoyan/monaco-react/issues/506
createRoot(document.getElementById('activity-stream-root')).render(
  <Provider store={store}>
    <BrowserRouter basename="/activity-stream">
      <App />
    </BrowserRouter>
  </Provider>,
)
